import { FunctionComponent } from 'react'
import { QuickFilter as QuickFilterProps } from './QuickFilter.types'
import './QuickFilter.scss'
import { Image } from '../primitives/Image/Image'
import { Text } from '../primitives/Text/Text'
import { useActions } from 'src/hooks/useActions'

export const QuickFilter: FunctionComponent<QuickFilterProps> = ({
  attributes
}) => {
  const { onClick } = useActions(attributes.actions)

  return (
    <button
      className="core-ux-quick-filter"
      onClick={onClick}
      tabIndex={0}
      type="button">
      <Image {...attributes.image} className="core-ux-quick-filter__image" />
      <Text {...attributes.title} className="core-ux-quick-filter__title" />
    </button>
  )
}
